import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=3fb5608c&scoped=true&"
import script from "./CustomerView.vue?vue&type=script&lang=js&"
export * from "./CustomerView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=3fb5608c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5608c",
  null
  
)

export default component.exports